import Resource from '../Resource'

export default class PreDiag extends Resource {
  static ENDPOINT = '/api/test/pre/prediag'

  constructor (args) {
    super()
    if (args) {
      Object.keys(args).forEach(arg => {
        this[arg] = args[arg]
      })
    }
  }

  static create (training, student, answers) {
    return new PreDiag({ training, student, answers })
  }

  mark () { // 채점
    this.score = this.answers.reduce((acc, cur) => acc + cur + 1, 0)
    this.level = this.score / 10
  }
}
